import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=415be75a&scoped=true&"
import script from "./AddMenu.vue?vue&type=script&lang=js&"
export * from "./AddMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415be75a",
  null
  
)

export default component.exports